import SPModuleLoader from './SPModuleLoader';

let result: SPModuleLoader = (window as any).spModuleLoader; // tslint:disable-line:no-any

if (!result) {
  require('./FrameworkPolyfills');

  result = require('./SPModuleLoaderProvider').default.instance;
}

export = result; // tslint:disable-line:export-name



// WEBPACK FOOTER //
// /src/index-webpack.ts